import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import Chart from "./Chart";
import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import NotFound from "../../../components/notfound/NotFound";
import { CustomAutocomplete } from "../../../components/custom/CustomAutocomplete";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import { useDashboardContext } from "../../../context/dashboard/DashboardContext";

const DashboardOrdersValue = () => {
  const { industriesList } = useDashboardContext();
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const {
    data = [],
    isLoading,
  } = useSWR(
    !selectedIndustry
      ? "/dashboard/buy-sell-value"
      : `/dashboard/buy-sell-value?industrial_group=${selectedIndustry?.id}`,
    fetchData,
    {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000,
    }
  );

  return (
    <Card sx={{ height: 400 }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          alignItems: "center",
          height: 380,
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "16px", lg: "18px" },
            fontWeight: 700,
          }}
        >
          {data.chart_title || "ارزش سفارش‌های خرید و فروش"}
        </Typography>

        {isLoading ?
          <Grid2 xs={12} sx={{ height: 380 }}>
            <Skeleton variant="rounded" height={"100%"} />
          </Grid2>
          : !data || data.length === 0 ? (
            <Box sx={{ margin: "auto", height: "100%" }}>
              <NotFound />
            </Box>
          ) : (
            <Grid2 container spacing={4} width={"100%"}>
              <Grid2 xs={12} sm={6} md={12} lg={6} xl={4}>
                <CustomAutocomplete
                  isLoading={industriesList.isLoading}
                  options={industriesList.data}
                  placeholder={"صنعت"}
                  value={selectedIndustry}
                  onChange={(_, newValue) => setSelectedIndustry(newValue)}
                />
              </Grid2>

              <Grid2 xs={12}>
                <Chart chartData={data} />
              </Grid2>
            </Grid2>
          )}
      </CardContent>
    </Card>
  );
};

export default DashboardOrdersValue;
